import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetAuth } from '../../Auth/AuthProvider';
import { APIROOT } from '../../Helpers/configs';
import { updateData } from '../../Helpers/requests';
import { Box, Grid, Typography, Divider, Button } from '@mui/material';
import { convertDate } from '../../Helpers/helpers';

const TechTimeAndAttendance = () => {
  const navigateBack = useNavigate();
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [forceUpdate, setForceUpdate] = useState(1);

  const [clockedIn, setClockedIn] = useState(false);
  const [clockedInTime, setClockedInTime] = useState(null);

  const clockInBlob = (action) => {
    const blob = {
      action: {
        do: action,
      },
    };
    return blob;
  };

  const handleClockIn = (event) => {
    const uri = '/actions';
    const path = '/tech/timeandattendance';
    const startBlob = clockInBlob('start_day');
    const endBlob = clockInBlob('stop_day');
    switch (event.target.id) {
      case 'clockIn':
        updateData(
          uri,
          startBlob,
          () => {
            setClockedIn(true);
            checkClock().then((data) => {
              setClockedInTime(data.data.value.clocked_in);
            });
          },
          setForceUpdate,
          // navigateBack,
          path,
          logout,
          enqNotification
        );
        break;
      case 'clockOut':
        updateData(
          uri,
          endBlob,
          () => setClockedIn(false),
          setForceUpdate,
          // navigateBack,
          path,
          logout,
          enqNotification
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    checkClock().then((data) => {
      setClockedIn(data.data.value.clocked_in);
      setClockedInTime(data.data.value.clocked_in);
    });
  }, []);

  return (
    <Box>
      <Grid container rowGap={2}>
        <Grid
          xs={12}
          md={8}
          sx={{
            border: '1px #c4c4c4 solid',
            // borderBottom: 'none',
            borderRadius: '15px 15px 0 0 ',
            padding: ' 10px 0 0 0 ',
            textTransform: 'capitalize',
          }}
          item
        >
          {/* {${convertDate(clockedInTime.toLocaleString())}} */}
          <Typography variant='h4'>
            {`You ${
              clockedIn
                ? `Clocked In On ${convertDate(
                    clockedInTime,
                    0,
                    10
                  )} At ${convertDate(clockedInTime, 12, 17)}`
                : 'Are Clocked Out'
            }
           
           `}
          </Typography>
        </Grid>
        <Grid
          xs={0}
          md={4}
          item
          sx={{ borderBottom: '1px #c4c4c4 solid' }}
        ></Grid>

        <Grid xs={12} md={6} item sx={{ textAlign: 'center' }}>
          <Button
            id='clockIn'
            disabled={clockedIn !== false}
            variant='contained'
            onClick={handleClockIn}
            sx={{
              margin: '15px ',
              width: 200,
              height: 200,
              fontWeight: '600',
              fontSize: '1.5em',
              borderRadius: '10px',
            }}
          >
            Clock In
          </Button>
        </Grid>
        <Grid xs={12} md={6} item sx={{ textAlign: 'center' }}>
          <Button
            disabled={clockedIn === false}
            variant='contained'
            color='secondary'
            id='clockOut'
            onClick={handleClockIn}
            sx={{
              margin: '15px ',
              width: 200,
              height: 200,
              fontWeight: '600',
              fontSize: '1.5em',
              borderRadius: '10px',
            }}
          >
            Clock Out
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: '15px' }} />
      <Box align='right'></Box>
    </Box>
  );
};

export default TechTimeAndAttendance;

async function checkClock() {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'clocked_in',
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
